import React, { ReactNode } from "react";

import { LocationProvider } from "@adsk/acc-locations-components";
import { useCurrentProjectId } from "@adsk/alloy-provider";

import { SearchContextProvider } from "../shared/SearchContext";

const SystemsProvider: React.FC<{ children?: ReactNode }> = ({ children }) => (
  <LocationProvider projectId={useCurrentProjectId()}>
    <SearchContextProvider>{children}</SearchContextProvider>
  </LocationProvider>
);

export default SystemsProvider;
